module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-4-img-sp_5b122156755e5f1c2c3880492faf96e4.png";